import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import styled from 'styled-components';
import { motion } from 'framer-motion';

// Context
import { useI18n } from '../../context/I18nContext';

const SectionContainer = styled.section`
  padding: 5rem 0;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: var(--border-radius);
  margin: 2rem 0;
`;

const MapContainer = styled(Paper)`
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: var(--box-shadow);
  margin-bottom: 2rem;
  height: 450px;
`;

const MapLegend = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
  
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;

const LegendItem = styled(Box)`
  display: flex;
  align-items: center;
`;

const LegendMarker = styled.span<{ color: string }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 0.5rem;
  background-color: ${props => props.color};
`;

const MapSection: React.FC = () => {
  const { t } = useI18n();
  
  return (
    <SectionContainer id="map">
      <Container>
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Box textAlign="center" sx={{ mb: 5 }}>
            <Typography variant="h2" color="primary" sx={{ position: 'relative', display: 'inline-block', mb: 4 }}>
              {t('map_title')}
              <Box sx={{ position: 'absolute', bottom: -10, left: 0, width: '100%', height: 3, bgcolor: 'primary.main' }} />
            </Typography>
            
            <Typography variant="h6" align="center" sx={{ maxWidth: '800px', margin: '1.5rem auto 0', color: '#555' }}>
              {t('map_subtitle')}
            </Typography>
          </Box>
          
          <MapContainer elevation={3}>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31760608.533152402!2d-69.64597325486392!3d-13.657381981376546!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9c59c7ebcc28cf%3A0x295a1506f2293e63!2sBrasil!5e0!3m2!1spt-BR!2sbr!4v1716466923452!5m2!1spt-BR!2sbr" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa do Brasil"
            />
          </MapContainer>
          
          <MapLegend>
            <LegendItem>
              <LegendMarker color="#006064" />
              <Typography variant="body2">
                {t('map_legend_audio')}
              </Typography>
            </LegendItem>
            
            <LegendItem>
              <LegendMarker color="#ff5252" />
              <Typography variant="body2">
                {t('map_legend_poi')}
              </Typography>
            </LegendItem>
          </MapLegend>
        </motion.div>
      </Container>
    </SectionContainer>
  );
};

export default MapSection;
